import axios from 'axios';

const token = localStorage.getItem('accessToken');

const apiBackoffice = axios.create({
    baseURL: process.env.VUE_APP_BACKOFFICE_API,
    headers: { 'Authorization': `bearer ${token}`, 'X-Client-Identifier': "DneBackOffice" }
});

export default apiBackoffice;